import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/api";

const LINKS = [
  { label: "The Penthouse", target: "condo" },
  { label: "The Fleet", target: "fleet" },
  { label: "Touchdown Royal", target: "package" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (target) => {
    setOpen(false);
    scrollToId(target);
  };

  return (
    <header
      data-testid="main-nav"
      className="fixed inset-x-0 top-0 z-50 border-b border-gold/15 bg-obsidian/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 sm:px-12 lg:px-20">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Sky Suite home">
          <Logo />
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.target}
              data-testid={`nav-link-${l.target}`}
              onClick={() => go(l.target)}
              className="font-display text-xs tracking-[0.2em] text-zinc-400 uppercase transition-colors hover:text-gold"
            >
              {l.label}
            </button>
          ))}
          <Link
            to="/account"
            data-testid="nav-account-link"
            className="font-display text-xs tracking-[0.2em] text-zinc-400 uppercase transition-colors hover:text-gold"
          >
            Sign In
          </Link>
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className="font-display text-xs tracking-[0.2em] text-zinc-600 uppercase transition-colors hover:text-gold"
          >
            Owner Login
          </Link>
          <a
            href="tel:+18007177052"
            data-testid="nav-phone-link"
            className="hidden items-center gap-2 font-display text-xs tracking-[0.15em] whitespace-nowrap text-gold transition-colors hover:text-gold-bright xl:flex"
          >
            <Phone size={14} /> 1-800-717-7052
          </a>
          <button
            data-testid="nav-reserve-btn"
            onClick={() => go("booking")}
            className="rounded-full bg-gold px-6 py-2.5 font-display text-xs font-semibold tracking-[0.2em] text-obsidian uppercase transition-all hover:bg-gold-bright hover:shadow-[0_0_30px_rgba(212,175,55,0.35)]"
          >
            Reserve
          </button>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          className="text-gold lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="border-t border-gold/10 bg-obsidian/95 px-6 py-6 backdrop-blur-xl lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <button
                key={l.target}
                data-testid={`nav-mobile-link-${l.target}`}
                onClick={() => go(l.target)}
                className="text-left font-display text-sm tracking-[0.2em] text-zinc-300 uppercase"
              >
                {l.label}
              </button>
            ))}
            <Link to="/account" data-testid="nav-mobile-account-link" className="font-display text-sm tracking-[0.2em] text-zinc-300 uppercase">
              Sign In
            </Link>
            <Link to="/admin" data-testid="nav-mobile-admin-link" className="font-display text-sm tracking-[0.2em] text-zinc-500 uppercase">
              Owner Login
            </Link>
            <a href="tel:+18007177052" data-testid="nav-mobile-phone-link"
              className="flex items-center gap-2 font-display text-sm tracking-[0.2em] text-gold uppercase">
              <Phone size={16} /> 1-800-717-7052
            </a>
            <button
              data-testid="nav-mobile-reserve-btn"
              onClick={() => go("booking")}
              className="mt-2 rounded-full bg-gold px-6 py-3 font-display text-xs font-semibold tracking-[0.2em] text-obsidian uppercase"
            >
              Reserve
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
